module.exports = __webpack_public_path__ + "static/media/santander.1b1e38f9.png";